import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import { Paper } from '@mui/material';

const dataElementId = 'report-example-data';

class ReportExamplePage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        //window.print();
    }

    filter = () => {

    }

    print = () => {
        document.getElementById('to-print').innerHTML = document.getElementById(dataElementId).innerHTML;
        window.print();
    }

    render() {
        const p = this.props;

        let data = [];
        for (let index = 0; index < 40; index++) {
            data.push(<tr key={index}><td>{index + 1}</td></tr>);

        }

        return (
            <div className="container">
                <br />
                <br />
                <div className="row">
                    <div className="col-lg-6">
                        <TextInput name={p.name + "FilterByName"}
                            label={'Filter by name'}
                            floatingLabelText={'Filter by name'}
                            hintText={'Filter by name'}
                            fullWidth={true}
                            required />
                    </div>
                    <div className="col-lg-6">
                        <Button name="buttonFilter"
                            className="pull-right"
                            label={'Filter'}
                            primary={true}
                            onTouchTap={() => this.filter()} />

                        <Button name="buttonPrint"
                            className="pull-right btn-space"
                            label={'Print'}
                            onTouchTap={() => this.print()} />
                    </div>
                </div>
                <Paper zDepth={2}>
                    <div className="row" id={dataElementId} style={{ padding: '10px 10px 10px 10px' }}>
                        <div className="col-lg-12">
                            <table className="table" style={{ border: 'none' }}>
                                <tbody>
                                    {data}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportExamplePage);